import React, { ComponentPropsWithoutRef } from 'react'

export const Label = ({
  labelText,
  htmlFor,
  required,
  ...rest
}: ComponentPropsWithoutRef<'label'> & {
  labelText: string
  htmlFor: string
  required?: boolean
}) => {
  return (
    <label
      htmlFor={htmlFor}
      {...rest}
      className="text-base block text-left text-textblack"
    >
      {labelText}
      {required && <span className="text-[#FF0000]">*</span>}
    </label>
  )
}
